import moment from "moment";
import React from "react";

import "./Diagnosis.scss";
import { ICONS } from "../../common/constants";
import Icon from "../Icon";

const Diagnosis = ({ asset, issueType, location, expiresAt, label }) => {
  const days = moment().diff(moment(expiresAt), "days");

  return (
    <div className="diagnosis">
      <table className="diagnosis__table">
        <thead>
          <tr>
            <th className="diagnosis__header">{label ? label : 'Asset'}</th>
            {location ? <th className="diagnosis__header">Location</th> : null}
            <th className="diagnosis__header">Issue Type</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="diagnosis__data">
              <div className="diagnosis__label">
                <div className="diagnosis__icon">
                  <Icon glyph={ICONS[asset]} weight="light" />
                </div>
                {asset}
              </div>
            </td>
            {location ? (
              <td className="diagnosis__data">
                <div className="diagnosis__label">{location}</div>
              </td>
            ) : null}
            <td className="diagnosis__data">
              <div className="diagnosis__label">
                <div className="diagnosis__icon">
                  <Icon glyph={ICONS[issueType]} weight="light" />
                </div>
                {issueType}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {expiresAt && days >= -30 ? (
        <div className="diagnosis__expires-at">
          <div className="diagnosis__state">
            <Icon glyph="exclamation" weight="solid" />
          </div>
          <div>
            Act fast, the warranty expires on{" "}
            <strong>{moment(expiresAt).format("MMM D, YYYY")}.</strong>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Diagnosis;
